import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var MergeFieldsFilledIcon = createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M15.14,13.5a.61.61,0,0,0,.68.57.94.94,0,0,0,.76-.33v-.48a.94.94,0,0,0-.76-.33A.6.6,0,0,0,15.14,13.5Z"
  }), /*#__PURE__*/_jsx("polygon", {
    points: "11.18 12.94 12.76 12.94 11.97 10.85 11.18 12.94"
  }), /*#__PURE__*/_jsx("path", {
    d: "M19,3H7A2,2,0,0,0,5.28,4H4A1,1,0,1,0,4,6H6.5a.5.5,0,0,1,0,1H5v3H4a1,1,0,0,0,0,2H6.5a.5.5,0,0,1,0,1H5v3H4a1,1,0,0,0,0,2H6.5a.5.5,0,0,1,0,1H5a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V5A2,2,0,0,0,19,3ZM13.3,14.46,13,13.62H11l-.32.84H9.76l1.73-4.39h1l1.73,4.39Zm4,0h-.69v-.34a1.35,1.35,0,0,1-1,.42,1.06,1.06,0,0,1-1.11-1,1,1,0,0,1,1.11-1,1.32,1.32,0,0,1,1,.41v-.47c0-.37-.3-.6-.75-.6a1.32,1.32,0,0,0-.94.41l-.28-.48A1.9,1.9,0,0,1,16,11.2c.7,0,1.32.3,1.32,1.15Z"
  })]
}), 'MergeFieldsFilledIcon');